// styles
import styles from './data-table.module.scss'

type HeaderItemProps = {
	readonly key: string
	readonly label: string
	readonly width?: string
	readonly nowrap?: boolean
}

export type RowProps = {
	readonly [key: string]: RowItemProps
}

type RowItemProps = {
	readonly content?: string | number | boolean | JSX.Element
}

type DataTableProps = {
	readonly className?: string
	readonly headers: HeaderItemProps[]
	readonly rows?: RowProps[]
}

const DataTable = ({
	className,
	headers,
	rows,
}: DataTableProps): JSX.Element => {
	return (
		<div className={[styles.dataTable, className].join(' ').trim()}>
			<table>
				<thead>
					<tr>
						{headers.map(({ key, label, width }) => {
							return (
								<th
									key={key}
									scope="column"
									style={{
										width: width,
										minWidth: width,
										maxWidth: width,
									}}
								>
									{label}
								</th>
							)
						})}
					</tr>
				</thead>
				<tbody>
					{rows?.map((row, index) => {
						return (
							<tr key={index}>
								{headers.map(({ key, nowrap }, index) => {
									const content =
										typeof row[key].content !== 'boolean'
											? row[key].content
											: row[key].content
											? 'Yes'
											: 'No'
									const cellStyle: React.CSSProperties = {
										whiteSpace: nowrap
											? 'nowrap'
											: undefined,
									}

									return index === 0 ? (
										<th
											key={key}
											scope="row"
											style={cellStyle}
										>
											{content}
										</th>
									) : (
										<td key={key} style={cellStyle}>
											{content}
										</td>
									)
								})}
							</tr>
						)
					})}
				</tbody>
			</table>
		</div>
	)
}

export default DataTable
